module.exports = __webpack_public_path__ + "static/media/giftImage.2abe1b71.png";